export default function removeOldMarker(): void {
   (document.querySelector('#main-menu [deepest]') as HTMLElement)?.removeAttribute('deepest');
   (document.querySelector('#main-menu [pre-deepest]') as HTMLElement)?.removeAttribute('pre-deepest');
}
